<template>
  <div class="common-home-content common-home-content-pb space_pl space_pr">
    <div class="survey-line"></div>
    <div
      class="survey-content"
      v-for="(survey, index) in surveys"
      :key="index"
    >
      <p class="survey-title">{{survey.name}}</p>
      <ul class="questions-ul">
        <li
          v-for="(question, question_index) in survey.questions"
          :key="question_index"
        >
          <p class="question-title">{{question.content}}</p>
          <div class="question-textarea" v-if="question.type == 3"></div>
          <ul class="options-ul clearfix" v-else>
            <li
              class="fl"
              v-for="(option, option_index) in question.options"
              :key="option_index"
            >{{option.content}}</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="fixed-button">
      <button @click="sendSurvey">立即发送</button>
    </div>
  </div>
</template>
<script>
import { _ } from "vue-underscore";
import http from "../../util/heraApiConfig";
import uniUrl from "../../util/uniUrl";
export default {
  data() {
    return {
      show: false,
      surveys: [],
      doctor_id: 1,
      survey_id: "",
      survey_name: "",
      questions: [],
      survey_value: "",
      user_id: "",
    platform_type: 2
    };
  },
  metaInfo() {
    return { title: this.survey_name };
  },
  beforeCreate() {
    this.$appUtils.showAppTrBtn({});
    this.survey_name = this.$route.query.survey_name;
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if (this.isApp == "IOS") {
      bridge.callHandler("showTrBtn", {'name': "保存"}, (response) => {
      });
      bridge.callHandler("getUserInfo", "", (response) => {
        this.token = response.token;
        this.doctor_id = response.doctor_id;
        this.user_id = response.user_id;
        this.platform_type = response.platform_type;
      });
      bridge.registerHandler('pageback', (data, responseCallback)=> {
        this.pageback()
      });
    } else if (this.isApp == "android") {
      this.$appUtils.showAppTrBtn({'name': "保存"});
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.token = user_info.token;
        this.platform_type = user_info.platform_type;
        this.doctor_id = user_info.doctor_id; this.user_id = user_info.user_id;
      }
    }


    this.survey_id = this.$route.params.id;
    this.survey_name = this.$route.query.survey_name;
   setTimeout(()=>{
     this.getDate();
   },1000)
    window.appTrBtnClick = () => this.editSurvey();
    window.appBack = () => this.pageback();
  },
  methods: {
    getDate() {
      let that = this;
      let params = {
        doctor_id: that.doctor_id
      };
      http
        .get("/surveys/" + that.survey_id + "/questions"+'?platform_type=' +this.platform_type, {
          params: params,
          headers: {
            Authorization: that.token
          }
        })
        .then(function(res) {
          that.surveys = res.data.data;
          that.show = true;
        });
    },
    editSurvey() {
      localStorage.setItem("survey_id", this.survey_id);
      localStorage.removeItem("local_survey_question");
      this.$router.push({ path: "/buildsurvey" });
    },
    sendSurvey() {
      let bridge = window.WebViewJavascriptBridge;
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "IOS") {
        if (this.user_id != "") {
          bridge.callHandler("sendSurvey", {
            survey_id: this.survey_id,
            user_id: this.user_id
          });
        } else {
          bridge.callHandler("sendSurvey", { survey_id: this.survey_id });
        }
      } else if (this.isApp == "android") {
        if (this.user_id != "") {
          this.$appUtils.appSendSurvey({
            survey_id: this.survey_id,
            user_id: this.user_id
          });
        } else {
          this.$appUtils.appSendSurvey({ survey_id: this.survey_id });
        }
      }
      if (this.$route.query.type == "uniapp") {
        if (this.$route.query.detail == "true") {
          window.open(
            uniUrl +
              "pages/chat/chat?item=" +
              JSON.stringify(item) +
              "&chat=" +
              this.chat +
              "&type=1"
          );
        } else {
          window.open(
            uniUrl +
              "pages/chatSearch/chatSearch?item=" +
              JSON.stringify(item) +
              "&chat=" +
              this.chat +
              "&type=3"
          );
        }
      }
    },
    pageback() {
      window.history.back();
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.new-build-survey {
  width: 32px;
  line-break: 16px;
  font-size: 16px;
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  color: rgba(172, 75, 56, 1);
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 14px;
}
.common-home-content-pb {
  padding-bottom: 52px;
}
.survey-line {
  width: 100%;
  height: 2px;
}
.survey-content {
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 10px;
  background: #ffffff;
  box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
  border-radius: 10px;
  .survey-title {
    margin-bottom: 20px;
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    text-align: center;
    color: rgba(51, 51, 51, 1);
  }
  .questions-ul {
    width: 100%;
    box-sizing: border-box;
    & > li {
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 30px;
      .question-title {
        margin-bottom: 2px;
        line-height: 16px;
        font-size: 16px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        text-align: left;
      }
      .question-textarea {
        margin-top: 14px;
        width: 100%;
        height: 60px;
        box-sizing: border-box;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 5px;
      }
      .options-ul {
        width: 100%;
        box-sizing: border-box;
        & > li {
          margin-top: 10px;
          margin-right: 10px;
          display: inline-block;
          box-sizing: border-box;
          border: 1px solid #e6e6e6;
          padding: 5px 10px;
          line-height: 14px;
          font-size: 14px;
          font-family: PingFang-SC-Medium;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          border-radius: 13px;
        }
      }
    }
    & > li:last-child {
      margin-bottom: 0;
    }
  }
}
.fixed-button {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 15px;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  & > button {
    display: block;
    width: 100%;
    box-sizing: border-box;
    line-height: 43px;
    font-size: 17px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    background: rgba(172, 76, 56, 1);
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/systempreview.vue